var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRate1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M42 21c0 11.598-9.402 21-21 21S0 32.598 0 21 9.402 0 21 0s21 9.402 21 21z",
    fill: props.fill
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.594 16.281c0 1.812-1.029 3.282-2.297 3.282-1.269 0-2.297-1.47-2.297-3.282S14.028 13 15.297 13c1.268 0 2.297 1.47 2.297 3.281zM29.406 16.281c0 1.812-1.028 3.282-2.297 3.282-1.268 0-2.297-1.47-2.297-3.282S25.841 13 27.11 13c1.269 0 2.297 1.47 2.297 3.281zM29.531 31.828c0-.819-.22-1.63-.65-2.386-.428-.756-1.056-1.443-1.849-2.022a9.217 9.217 0 00-2.767-1.352A11.313 11.313 0 0021 25.594c-1.12 0-2.23.161-3.265.474a9.217 9.217 0 00-2.768 1.352c-.792.579-1.42 1.266-1.849 2.022a4.817 4.817 0 00-.65 2.386H29.532z",
    fill: "#111827"
  })));
}
export default SvgRate1;